import React from 'react';
import logo from '../img/logo1.png';
import { trackEvent } from '../analytics';

export default function BlogFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div><a href="/#start" className="site-brand"><img src={logo} width="32" height="32" alt="" /><span>현장통</span></a><p className="site-footer-tagline">사람과 현장을 잇는 현장관리</p></div>
        <div className="site-footer-details">
          <p><strong>㈜통하는사람들</strong></p>
          <p>서울시 송파구 올림픽로49길 8, 지하 1층</p>
          <p>사업자등록번호: 783-88-02775 <span> / </span> 개인정보관리책임자: 홍영대</p>
          <div className="site-footer-contacts"><a href="tel:0232722302" onClick={() => trackEvent('phone_click', { location: 'footer', page: window.location.pathname })}>Tel. 02-3272-2302</a><span>Fax. 02-6455-9114</span><a href="mailto:admin@hongtong.kr">admin@hongtong.kr</a></div>
          <p className="site-copyright">© 2023 통하는사람들. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
